import React, { useState } from "react";
import { toast } from "sonner";
import { Quote, Check } from "lucide-react";

const AUTHOR = "Bunic, V.";

const parse = (item) => {
  const parts = (item.meta || "").split(" · ");
  const vol = item.meta.match(/Vol\. (\w+)(?:, No\. (\w+))?/);
  return {
    journal: parts[1] || "",
    volume: vol?.[1] || "",
    issue: vol?.[2] || "",
    pages: (item.meta.match(/pp\. ([\w–-]+)/)?.[1] || "").replace("-", "–"),
    doi: item.meta.match(/DOI: (\S+)/)?.[1] || "",
  };
};

export const formatCitation = (item, style) => {
  const c = parse(item);
  const year = item.year || "n.d.";
  const vi = `${c.volume}${c.issue ? `(${c.issue})` : ""}`;
  const link = c.doi ? `https://doi.org/${c.doi}` : item.url;
  if (item.tag === "Book") {
    const pub = /^(Published|Author)/.test(c.journal) ? "" : c.journal;
    return style === "apa"
      ? `${AUTHOR} (${year}). ${item.title}.${pub ? ` ${pub}.` : ""} ${link}`
      : `${AUTHOR} (${year}) ${item.title}.${pub ? ` ${pub}.` : ""} Available at: ${link}.`;
  }
  if (style === "apa") return `${AUTHOR} (${year}). ${item.title}. ${c.journal}${vi ? `, ${vi}` : ""}${c.pages ? `, ${c.pages}` : ""}. ${link}`;
  return `${AUTHOR} (${year}) '${item.title}', ${c.journal}${vi ? `, ${vi}` : ""}${c.pages ? `, pp. ${c.pages}` : ""}. ${c.doi ? `doi: ${c.doi}` : `Available at: ${link}`}.`;
};

const copy = async (text) => {
  try { await navigator.clipboard.writeText(text); }
  catch {
    const ta = Object.assign(document.createElement("textarea"), { value: text });
    document.body.appendChild(ta); ta.select(); document.execCommand("copy"); ta.remove();
  }
};

export const CiteButtons = ({ item, testid }) => {
  const [done, setDone] = useState(null);
  const onCopy = async (style) => {
    await copy(formatCitation(item, style));
    setDone(style);
    toast.success(`${style === "apa" ? "APA" : "Harvard"} citation copied`);
    setTimeout(() => setDone(null), 2000);
  };
  return (
    <div className="flex items-center gap-1.5 flex-wrap" data-testid={`cite-${testid}`}>
      <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-[var(--navy)]"><Quote size={12}/> Copy citation</span>
      {["apa", "harvard"].map((s) => (
        <button key={s} type="button" onClick={() => onCopy(s)} title={formatCitation(item, s)}
          className="inline-flex items-center gap-1 rounded-full border border-[var(--border-warm)] bg-white px-3 py-1 text-[11px] font-semibold text-[var(--navy)] hover:bg-[var(--muted-surface)] transition-colors"
          data-testid={`cite-${s}-${testid}`}>
          {done === s && <Check size={11} className="text-emerald-600"/>}{s === "apa" ? "APA" : "Harvard"}
        </button>
      ))}
    </div>
  );
};
